import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import therapistService from '../../../services/apiServices/therapist-scheduling/therapistService';
import { TherapistAction, documentationActions } from '../../actions/constant';
import nProgress from 'nprogress';

const { THERAPIST_PROFILE_REQUEST, THERAPIST_PROFILE_SUCCESS, THERAPIST_PROFILE_FAILURE } =
  TherapistAction;
const { REQUEST_GET_SIGNATURE_ACCESS } = documentationActions;

function* getTherapistProfile(): SagaReturnType<any> {
  try {
    nProgress.start();
    const response = yield call(therapistService.getTherapistProfile);
    if (response?.status === 200) {
      nProgress.done();
      localStorage.setItem('facility_timezone', response.data?.data?.timeZone);
      yield put({
        type: REQUEST_GET_SIGNATURE_ACCESS,
        payload: response.data?.data?.currentRoles,
        params: {
          discipline: response.data?.data?.discipline
        },
      });
      yield put({ type: THERAPIST_PROFILE_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    nProgress.done();
    yield put({ type: THERAPIST_PROFILE_FAILURE, payload: error });
  }
}

function* getTherapistProfileSaga() {
  yield takeEvery(THERAPIST_PROFILE_REQUEST, getTherapistProfile);
}

export default getTherapistProfileSaga;
